import { notifications } from "@mantine/notifications";
import { updateProspect } from "../../../../../../../api/PRMAPI";
import PRMStatusSelector from "../../../../../../../components/Selectors/PRMStatusSelector";
import {
  useLeadsContainerStore,
  useLeadsSheetStore,
} from "../../../../../../../stores/LeadsStore";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { useState } from "react";

const Status = () => {
  const lang = useLanguage((s) => s.language);
  const setIndex = useLeadsSheetStore((s) => s.setIndex);
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const setCurrentContainer = useLeadsSheetStore((s) => s.setCurrentContainer);
  const updateContainer = useLeadsContainerStore((s) => s.updateContainer);
  const containers = useLeadsContainerStore((s) => s.containers);
  const [loading, setLoading] = useState(false);

  const onStatusChange = (newStatus) => {
    setLoading(true);
    let newItem =
      newStatus === "to_call"
        ? { ...current, custom_status: null, status: "to_call" }
        : { ...current, custom_status: parseInt(newStatus) };
    updateProspect({
      id: current.id,
      custom_status: newItem.custom_status,
      status: newItem.status,
    })
      .then(() => {
        notifications.show({
          message: lang.prm.prospect_moved,
          color: "tertiary.8",
        });

        setCurrent(newItem);
        // Delete the item from its container
        let newItemsOnCurrentContainer = currentContainer.items.filter(
          (item) => item.id !== current.id
        );
        updateContainer(currentContainer.id, {
          items: newItemsOnCurrentContainer,
          total: currentContainer.total - 1,
          needCacheReset: true,
        });

        // Add the item to its next container
        let newContainer = containers.find(
          (x) => x.id.toString() === newStatus
        );
        let newItemsFuture = [...newContainer.items];
        newItemsFuture.unshift({
          ...newItem,
          status_changed_date: new Date(),
        });
        updateContainer(newContainer.id, {
          total: newContainer.total + 1,
          items: newItemsFuture,
          needCacheReset: true,
        });
        setCurrentContainer({
          ...newContainer,
          total: newContainer.total + 1,
          items: newItemsFuture,
        });
        setIndex(0);
      })
      .finally(() => setLoading(false));
  };

  return (
    <PRMStatusSelector
      value={current?.custom_status?.toString() || current?.status}
      onChange={onStatusChange}
      noLabel={true}
      w={150}
      disabled={loading || !current?.permission?.write_permission}
      required
      defaultOptions={containers.map((x) => ({
        value: x.id?.toString(),
        label: x.name,
        disabled: x.status && x.status !== "to_call",
      }))}
    />
  );
};

export default Status;
